export class AjaxRequest {


    async request(handler, data, withMemberClubId) {
        let id = document.querySelector('#user_club')
        if (id && withMemberClubId) {
            data['clubId'] = id.value;
        }
        let inputData = {action: handler, ...data}
        let requestData = new URLSearchParams(inputData).toString();
        return new Promise((resolve, reject) => {
            $.ajax({
                url: ajaxurl,
                type: "POST",
                dataType: 'json',
                data: requestData,
                success: function (response) {
                    if (response['error']?.includes('refreshToken failed')) {
                        window.location.href = "/"
                    }
                    resolve(response);
                },
                error: function (error) {
                    reject(error)
                }
            });
        })
    }

}